import { css } from '@emotion/react'
import { BaseButton } from '@/components/button/BaseButton'
import { useNavigate } from 'react-router-dom'

// ボタンエリア
const buttonAreaStyle = (width: number) => css`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: ${width}px;
  max-width: 100%;
  margin-top: 24px;
`

// アイコンスタイル
const iconStyle = css`
  width: 16px;
  height: 16px;
  fill: currentColor;
  flex-shrink: 0;
`

// 右側エリア（エラーメッセージ＋登録ボタン）
const rightAreaStyle = css`
  display: flex;
  align-items: center;
`

// エラーメッセージスタイル
const errorMessageStyle = css`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 400;
  font-size: 1.2rem;
  color: #FF0000;
  margin-right: 24px;
`

type Props = {
  cancelUrl: string
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void
  onCancel?: () => void
  submitLabel?: string
  isDisabled?: boolean
  width?: number
  showError?: boolean
}

export const FormButtonArea = ({
  cancelUrl,
  onSubmit,
  onCancel,
  submitLabel = '登録',
  isDisabled = false,
  width = 918,
  showError = false,
}: Props) => {
  const navigate = useNavigate()

  return (
    <div css={buttonAreaStyle(width)}>
      <BaseButton
        color="normal"
        size="fixed38"
        onClick={() => (onCancel ? onCancel() : navigate(cancelUrl))}
      >
        キャンセル
      </BaseButton>
      <div css={rightAreaStyle}>
        {showError && (
          <span css={errorMessageStyle}>
            保存できませんでした。入力内容をご確認ください。
          </span>
        )}
        <BaseButton
          color="primary"
          size="fixed38"
          onClick={onSubmit}
          disabled={isDisabled}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            css={iconStyle}
          >
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
          </svg>
          {submitLabel}
        </BaseButton>
      </div>
    </div>
  )
}
